import React from "react";
import { Link } from "react-router-dom";
import NumenteLogo from "../../assets/Numente-auth-logo.png";
import authLeftBillboard from "../../assets/auth-left-billboard.png";
import "./ProviderAuthLayout.css";

/**
 * Shared split-screen auth shell for Provider.Numente.io
 * (Sign In, Reset Password, Verification, Create/Change Password).
 */
const ProviderAuthLayout = ({ children }) => {
  return (
    <div className="provider-auth">
      <aside className="provider-auth-brand" aria-hidden="true">
        <img
          className="provider-auth-brand-image"
          src={authLeftBillboard}
          alt=""
        />
      </aside>

      <main className="provider-auth-panel">
        <div className="provider-auth-panel-inner">
          <Link to="/login" className="provider-auth-logo" aria-label="Numente home">
            <img src={NumenteLogo} alt="Numente" />
          </Link>
          {children}
        </div>
      </main>
    </div>
  );
};

export default ProviderAuthLayout;
